<template>
  <div>
    <el-table :data="compares">

      <el-table-column prop="point" :label="$t('admin.point')">
        <template slot-scope="scope">
          <span>{{ pathTran(scope.row.point) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" :label="$t('admin.date')"></el-table-column>
      <el-table-column prop="channel" :label="$t('admin.channel')"></el-table-column>
      <el-table-column prop="action" :label="$t('admin.action')">
        <template slot-scope="scope">
          <el-button type="danger" icon="el-icon-delete" circle
            @click="removeCompare({ measurementId: scope.row.measurementId, channel: scope.row.channel })">
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button style="margin-top:10px;" @click="init()"> {{ $t("measurement.compare") }}</el-button>

    <el-dialog width="80%" :visible.sync="showCompares"   :title="$t('measurement.compare')"
      style="text-align:center; z-index:100" append-to-body>

      <div style="text-align:left">
        <div style="width:100%" v-bind:style="{ color: colors[i] }" v-for="(v, i) in signals">
          {{ getPointPath(v.point) }},{{ v.channel }}, {{ parseDate(v.createdAt) }}</div>
      </div>
      <div id="fft-chart" style="height:250px" ref="fft-chart"></div>
      <hr>
      <div  id="time-chart" style="height:250px" ref="time-chart"></div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import treeHelper from '../util/treeHelper';
import Plotly from 'plotly.js';
import dayjs from 'dayjs-ext';
import preferences from '../util/preferences';


export default {
  name: "CompareMeasurement",
  data() {
    return {
      showCompares:false,
      signals: [],
      colors: ['red', 'green', 'blue', 'brown', 'orange'],

    };
  },
  created() {
  },
  mounted() {



  },
  computed: {

    ...mapState("compareSpectrum", ["compares"]),
    ...mapState("tree", ["flatTree"])
  },
  methods: {
    pathTran(id) {
      if (id) {
        return treeHelper.pointIdToPath(this.flatTree,id);
      } else {
        return "";
      }
    },
    ...mapActions("compareSpectrum", ["removeCompare"]),
    getPointPath(id) {
      return treeHelper.pointIdToPath(this.flatTree, id);
    },
    parseDate(s) {
      return dayjs(s).format(preferences().localization.dateFormat);
    },
    async prepareFFTCharts() {
      let axises = {};
      axises["xaxis"] = {
        automargin: true,
        title: this.$t("measurement.fft") + "(Hz)",
        showticklabels: true,
      };

      let layout = {
        height: 220,
        colors: this.colors,
        margin: {
          l: 30,
          r: 30,
          b: 0,
          t: 0,
          pad: 0,
        },
        showlegend: false,
        ...axises,
        modebar: {
          orientation: "h",
        },
        displayLogo: false,
      };


      let fftChart = this.$refs["fft-chart"];
      let series = this.signals.map((x, i) => {
        return {
          x: x.fft.x,
          y: x.fft.y,
          name: "serie1",
          line: {
            color: this.colors[i],
            width: 0.7,
          },
          type: "scatter",
          xaxis: "x"
          // xaxis: "x" + (i + 1),
        };
      });
      Plotly.newPlot(
        fftChart,
        series,
        layout,
        { responsive: true }
      );
    },
    async prepareTimeCharts() {
      // let axises = {};
      // for (let i = 0; i < this.signals.length; i++) {
      //   if (i == 0) {
      //     axises["xaxis"] = {
      //       automargin: true,
      //       title: this.$t("measurement.time") + "(s)",
      //       showticklabels: true,
      //     };
      //   } else {
      //     axises["xaxis" + (i + 1)] = {
      //       automargin: true,
      //       title: this.$t("measurement.time") + "(s)",
      //       showticklabels: true,
      //       overlaying: 'x',
      //       side: (i % 2 == 0 ? "top" : "bottom"),
      //     };

      //   }
      // }
      // console.log("axises", axises);
      let layout = {
        height: 220,
        margin: {
          l: 30,
          r: 30,
          b: 0,
          t: 0,
          pad: 0,
        },
        showlegend: false,
        xaxis: {
          automargin: true,
          title: this.$t("measurement.time") + "(s)",
          showticklabels: true,
        },
        modebar: {
          orientation: "h",
        },
        displayLogo: false,
      };


      let timeChart = this.$refs["time-chart"];
      let series = this.signals.map((x, i) => {
        return {
          x: x.time.x,
          y: x.time.y,
          name: "serie1",
          line: {
            color: this.colors[i],
            width: 0.7,
          },
          type: "scatter",
          // xaxis: "x" + (i + 1),
        };
      });

      Plotly.newPlot(
        timeChart,
        series,
        layout,
        { responsive: true }
      );
    },
    async init() {
      this.showCompares=true;
      setTimeout(()=>{


     
      this.signals = this.compares.map(x => {
        return {
          measurementId: x.measurementId,
          point: x.point,
          channel: x.channel,
          createdAt: x.createdAt,
          time: {
            x: x.time.x,
            y: x.time.y
          },
          fft: {
            x: x.fft.x,
            y: x.fft.y
          }
        };
      });

      this.prepareTimeCharts();
      this.prepareFFTCharts();
    },10)

    }
  }
};
</script>
<style scoped>

</style>